import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import { closeTooltip } from "../actions";

export function* investSkillPointSaga({ generalId, skillId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "investSkillPoint",
      genId: generalId,
      skillId
    });

    const { data } = JSON.parse(response.data);

    yield put(actions.updateGeneral(
      data.general,
    ));

    const {
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      resources,
      resourceBalances,
      slotChains,
      canDoLabyrinth,
      labyrinthAttemptLimit,
      spells,
      army,
      armyFormation,
      canSendCounterintelligence,
      limitingCrimes,
      crimeTypes,
      marketLimit,
      development
    } = data;

    if (resources) {
      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));
    }

    yield put(actions.updateState({
      canDoLabyrinth,
      labyrinthAttemptLimit,
      marketLimit
    }));

    if (slotChains) {
      yield put(actions.updateState({
        slotChains
      }));
    }

    if (hasFinishedQuest) {
      yield put(actions.updateState({
        hasFinishedQuest,
        availableQuests,
        finishedQuests
      }));
    }

    if (development) {
      yield put(actions.updateDevelopment(development));
    }

    if (spells) {
      yield put(actions.updateState({
        spells
      }));
    }

    if (army) {
      yield put(actions.updateState({
        army,
        armyFormation
      }));
    }

    if (canSendCounterintelligence !== undefined) {
      yield put(actions.updateState({
        canSendCounterintelligence,
        limitingCrimes,
        crimeTypes
      }));
    }

    yield put(closeTooltip());
  } catch (error) {
    console.log(error.message);
  }
}

export function* investTechPointSagaXP({ generalId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "investTechPointXP",
      genId: generalId
    });

    const { data } = JSON.parse(response.data);
    const { general, development } = data;

    if (general) {
      yield put(actions.updateGeneral(
        data.general,
      ));
    }

    yield put(actions.updateState({
      development
    }));

    yield put(closeTooltip());
  } catch (error) {
    console.log(error.message);
  }
}

export function* investStrengthBonusSaga({ generalId, bonusId, tier }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "investStrengthBonus",
      genId: generalId,
      bonusId,
      tier
    });

    const { data } = JSON.parse(response.data);

    const {
      general,
      resources,
      resourceBalances,
      ljpPoints
    } = data;

    if (general) {
      yield put(actions.updateGeneral(
        data.general,
      ));
    }

    if (resources) {
      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));

      yield put(actions.updateState({
        ljpPoints
      }));
    }

    yield put(actions.closeTooltip());
  } catch (error) {
    console.log(error.message);
  }
}
